module.exports = __webpack_public_path__ + "static/media/slide2_mobile_small.85859cfa.jpg";